var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(!_vm.countryScorecard)?_c('ControlGroup',[_c('Dropdown',{attrs:{"options":['Region', 'Category'],"label":"Show policies by"},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}})],1):_vm._e(),_c('Tabs',[_c('Tab',{attrs:{"title":"Snapshot"}},[(_vm.mode === 'Region')?_c('PolicySnapshot',{attrs:{"countries":_vm.countryList,"debug":_vm.debug}}):_vm._e(),(_vm.mode === 'Category')?_c('PolicySnapshot',{attrs:{"countries":_vm.countryList,"showAll":"","debug":_vm.debug}}):_vm._e()],1),_c('Tab',{attrs:{"title":"All policies"}},[_c('DataGetter',{attrs:{"url":`${_vm.apiRoute}/policies/v2/`,"params":{ topic: ['Critical Minerals'] },"formatter":_vm.formatPolicies},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('SortableTable',{attrs:{"animated":"","headers":[
            _vm.mode === 'Region'
              ? {
                  key: 'country',
                  label: 'Region',
                  sortable: true,
                  align: 'left',
                }
              : {
                  key: 'category',
                  label: 'Category',
                  sortable: true,
                  align: 'left ',
                },
            { key: 'title', label: 'Name', sortable: true, align: 'left' },
            { key: 'year', label: 'Start year', sortable: true },
            {
              key: 'type',
              label: 'Policy type',
              sortable: false,
              align: 'center',
            },
            { key: 'status', label: 'Status', sortable: true },
          ],"linkField":"title","items":data}})]}}])})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }